export enum TransferActionType {
  SHAREFROM = 'SHAREFROM',
  SHARETO = 'SHARETO',
  SHARECHECKWITHDRAWAL = 'SHARECHECKWITHDRAWAL',
  STOPCHECK = 'STOPCHECK',
  // it is not typo
  LOANREGULAR = 'LOANREGULAR',
  LOANPAYOFF = 'LOANPAYOFF',
  LOANPRINCIPALONLY = 'LOANPRINCIPALONLY',
  LOANSKIP = 'LOANSKIP',
  LOANMINIMUM = 'LOANMINIMUM',
  LOANLASTSTATEMENT = 'LOANLASTSTATEMENT',
  LOANCUSTOM = 'LOANCUSTOM',
  LOANFROM = 'LOANFROM',
  M2MTO = 'M2MTO',
  FUNDSHARE_EXT = 'FUNDSHARE_EXT',
  FUNDSHARE_INT = 'FUNDSHARE_INT',
  LINKEXTACC = 'LINKEXTACC',
  TOTEMPLATE = 'TOTEMPLATE',
  FROMTEMPLATE = 'FROMTEMPLATE',
  TORECIPIENT_ONEOFFINVOICE = 'TORECIPIENT_ONEOFFINVOICE',
}
